<template>
  <div class="header-container">
    <div class="header-left">
      <img src="@images/logo.png"
           alt="合作库" />
      <h1>供应商查询系统</h1>
      <!-- <div class="search-wrapper">
        <el-input placeholder="请输入您需要的服务或功能"
                  v-model="searchKeyword"
                  size="small"
                  @keyup.enter="handleSearch">
        </el-input>
        <i class="iconfont icon-search"
           @click="handleSearch"></i>
      </div> -->
    </div>
    <div class="header-right">
      <div class="phone-wrapper"
           @mouseenter="handleMouseneter"
           @mouseleave="handleMouseleave">
        <i class="iconfont icon-phone"></i>
        <span>手机端</span>
        <div class="qrcode-box"
             v-show="isShowQrcodeBox"
             @mouseenter="handleMouseneter"
             @mouseleave="handleMouseleave">
          <img src="@images/phoneend_qrcode.png"
               alt="手机端二维码">
        </div>
      </div>

      <div class="account-wrapper">
        <i class="iconfont icon-account"></i>
        <span>{{ userInfo.accountName }}</span>
      </div>
      <div class="logout"
           @click="logout">
        <i class="iconfont icon-exit"></i>
        <span>退出</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isShowQrcodeBox: false,
      timer: 0,
      auth: window.localStorage.getItem('auth'),
      userInfo: {}
    }
  },
  watch: {
    // 监听登录是否过期
    auth (newVal) {
      if (!newVal) {
        this.$router.replace('/login')
      }
    }
  },
  created () {
    this.getUserInfo()
  },
  methods: {
    // 获取用户信息
    getUserInfo () {
      this.$http
        .get('/api/services/inquiryApp/account/GetCurrentUserInformation')
        .then(res => {
          if (res.success) {
            this.$store.commit('setUserInfo', res.result)
            this.userInfo = res.result
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleMouseleave () {
      this.timer = setTimeout(() => {
        this.isShowQrcodeBox = false
      }, 500)
    },
    handleMouseneter () {
      clearTimeout(this.timer)
      this.isShowQrcodeBox = true
    },
    logout () {
      this.$store.commit('logout')
    }
  }
}
</script>
<style lang="less" scoped>
.header-container {
  height: 60px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-left {
  display: flex;
  align-items: center;
  img {
    height: 55px;
    margin-right: 10px;
  }
  h1 {
    margin-right: 30px;
    font-size: 16px;
    font-weight: bold;
    color: #027cff;
  }
  .search-wrapper {
    width: 240px;
    height: 40px;
    border-radius: 20px;
    background-color: #f6f6f6;
    display: flex;
    align-items: center;
  }
  .el-input {
    width: 200px;
    margin-left: 10px;
    /deep/ .el-input__inner {
      border: none;
      border-radius: 0;
      background-color: #f6f6f6;
    }
  }
  .icon-search {
    font-size: 18px;
    color: #80848b;
    cursor: pointer;
  }
}
.header-right {
  height: 60px;
  margin-right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #b7bbc8;
  .phone-wrapper,
  .account-wrapper,
  .logout {
    margin-right: 20px;
    position: relative;
    display: flex;
    align-items: center;
    .iconfont {
      font-size: 20px;
      margin-right: 5px;
    }
  }
  .phone-wrapper {
    cursor: default;
  }
  .qrcode-box {
    padding: 10px;
    position: absolute;
    z-index: 1000;
    left: -15px;
    top: 30px;
    background-color: #fff;
    border-radius: 4px;
    transition: all 0.5s;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    img {
      width: 100px;
      height: 100px;
    }
  }
  .logout {
    &:hover {
      color: #80848b;
      cursor: pointer;
    }
  }
}
</style>
